import { type ReactNode, useRef } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

type ConfirmationModalProps = {
    isOpen: boolean;
    onSubmit: () => void;
    closeModal: () => void;
    isLoading?: boolean;
    title: string;
    children: ReactNode;
    confirmButtonText?: string;
    cancelButtonText?: string;
};

export const ConfirmationModal = ({
    isOpen,
    onSubmit,
    closeModal,
    confirmButtonText,
    cancelButtonText,
    isLoading,
    title,
    children
}: ConfirmationModalProps) => {
    const initialFocus = useRef<HTMLButtonElement>(null);
    const { t } = useTranslation('commons');

    return (
        <Modal open={isOpen} onDismiss={closeModal} initialFocus={initialFocus} className="!z-100">
            <Modal.Body>
                <Modal.Title>{title}</Modal.Title>
                <Modal.Content>{children}</Modal.Content>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        className="w-1/2"
                        ref={initialFocus}
                        onClick={closeModal}
                        disabled={isLoading}>
                        {cancelButtonText || t('no')}
                    </Button>
                    <Button onClick={onSubmit} className="w-1/2" isLoading={isLoading}>
                        {confirmButtonText || t('yes')}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmationModal;
